export default "__VITE_ASSET__BVAIoVq8__"